<template>
  <v-container>
    <v-calendar ref="calendar"
                :expanded="expanded"
                borderless
                @dayclick="dayClick"
                :columns="columns"
                :min-date=calendarstart
                :max-date=calendarend
                :show-overflow="true"
                :attributes="attributes"/>

    <div class="d-flex flex-column justify-center justify-space-between mb-2 mt-4">
      <v-row class="flex-row">
        <span class="flex-1-0-0 text-center">{{shiftStrings.frueh}}</span>
        <span class="flex-1-0-0 text-center">{{shiftStrings.mittel}}</span>
        <span class="flex-1-0-0 text-center">{{shiftStrings.spaet}}</span>
      </v-row>
      <v-row class="flex-row">
        <span class="flex-1-0-0 text-center">{{shiftStrings.ne}}</span>
        <span class="flex-1-0-0 text-center">{{shiftStrings.geteilt}}</span>
        <span class="flex-1-0-0 text-center">{{shiftStrings.frei}}</span>
      </v-row>
    </div>
  </v-container>
</template>

<script lang="ts">
import {computed, defineComponent, onMounted, ref, toRef, watch} from "vue";
import {useScreens} from "vue-screen-utils";
import {GetWishData} from "@/data/wishData";
import {store} from "@/store";
import {GetEmployVacationData} from "@/data/employData";
import {GetUserData} from "@/data/userData";

export default defineComponent({
  name: "WorkCalendar",
  setup(props) {
    const calendar = ref(null);

    const nightexpress = ref(store.state.calendarData.newCalendarData.nightexpressData);
    const holidays = ref(store.state.calendarData.newCalendarData.holidaysData);
    
    const { mapCurrent } = useScreens({
      xs: '0px',
      sm: '640px',
      md: '768px',
      lg: '1024px',
    });
    const columns = mapCurrent({ lg: 2 }, 1);
    const expanded = mapCurrent({ sm: false, lg: true }, true);
    let wishPeriod = props.wishPeriod;

    const calendarstart = ref(null)
    const calendarend = ref(null)

    //const employWishData = props.employWishData;
    //const employWishData = toRef(props, "employWishData")
    const ruleBreaks = props.ruleBreaks;
    const employVacationData = ref(null);
    const fullEmployWishData = ref(null);

    const shiftStrings = computed(() => {
//      console.log("shiftSettings", fullEmployWishData.value);

      const shiftCounts = {
        frueh: fullEmployWishData.value?.dates.filter(d => d.shift === 1).length,
        mittel: fullEmployWishData.value?.dates.filter(d => d.shift === 2).length,
        spaet: fullEmployWishData.value?.dates.filter(d => d.shift === 3).length,
        geteilt: fullEmployWishData.value?.dates.filter(d => d.shift === 5).length,
        ne: fullEmployWishData.value?.dates.filter(d => d.shift === 4).length,
        frei: fullEmployWishData.value?.dates.filter(d => d.shift === 10).length,
      };

      return {
        frueh: `${shiftCounts.frueh}xFrüh`,
        mittel: `${shiftCounts.mittel}xMittel`,
        spaet: `${shiftCounts.spaet}xSpät`,
        geteilt: `${shiftCounts.geteilt}xGeteilt`,
        ne: `${shiftCounts.ne}xNE`,
        frei: `${shiftCounts.frei}xFrei`,
      };
    });
    
    const attributes = computed(() => {
      let dynamicAttributesRules = [];
      let baseAttributeContent = [];
      let dynamicAttributesVacation = {};
      let dynamicAttributesHolidays = {};
      
      const baseAttributes = [
        {
          key: '1', // FrÃ¼h
          highlight: {
            color: 'orange',
            fillMode: 'light',
            contentClass: 'italic',
          },
          dates: [],
        },
        {
          key: '2', // Mittel
          highlight: {
            color: 'pink',
            fillMode: 'solid',
            contentClass: 'italic',
          },
          dates: [],
        },
        {
          key: '3', // SpÃ¤t
          highlight: {
            color: 'purple',
            fillMode: 'solid',
            contentClass: 'italic',
          },
          dates: [],
        },
        {
          key: '5', // Geteilt
          highlight: {
            color: 'teal',
            fillMode: 'solid',
            contentClass: 'italic',
          },
          dates: [],
        },
        {
          key: '4', // NE
          highlight: {
            color: 'blue',
            fillMode: 'solid',
            contentClass: 'italic',
          },
          dates: [],
        },
        {
          key: '10', // Frei
          highlight: {
            color: 'green',
            fillMode: 'solid',
            contentClass: 'italic',
          },
          dates: [],
        },
        {
          key: 'nightexpress', // Nachtexpress
          bar: 'darkblue',
          popover: {
            label: 'Nachtexpress',
            visibility: 'hover',
          },
          dates: [],
        },
      ];
      
      if(fullEmployWishData.value)
      {
        // Merge static baseAttributes with dynamically created attributes
        baseAttributeContent =  baseAttributes.map(attribute => {
          let datesForAttribute;
          if (attribute.key === 'nightexpress') {
            datesForAttribute = nightexpress.value
                .filter(dateObject => dateObject.nightexpress === 1)
                .map(dateObject => dateObject.Date);
          } else if (attribute.key !== 'nightexpress') {
            if(fullEmployWishData.value)
            {
              datesForAttribute = fullEmployWishData.value.dates
                  .filter(dateObject => dateObject.shift.toString() === attribute.key)
                  .map(dateObject => dateObject.date);
            }
          }

          return {
            ...attribute,
            dates: datesForAttribute,
          };
        });
      }

      if(holidays.value)
      {
        dynamicAttributesHolidays = [...new Set(holidays.value.map(dateObject => dateObject.Name))].map(name => ({
          bar: 'green',
          popover: {
            label: name,
            visibility: 'hover',
          },
          dates: holidays.value
              .filter(dateObject => dateObject.Name === name)
              .map(dateObject => dateObject.Date),
        }));
      }
      
      if(employVacationData.value)
      {
        dynamicAttributesVacation = {
          highlight: {
            color: 'green',
            fillMode: 'outline',
          },
          popover: {
            label: "Urlaub",
            visibility: 'hover',
          },
          dates: employVacationData.value.map(dateObject => dateObject.date),
        };
        
      }

      
      if(ruleBreaks)
      {
        dynamicAttributesRules = [...new Set(ruleBreaks.map(dateObject => dateObject.ruleShortMessage))].map(name => ({
          key: name, // Using name as the key
          bar: 'red',
          popover: {
            label: name,
            visibility: 'hover',
          },
          dates: ruleBreaks
              .filter(dateObject => dateObject.ruleShortMessage === name)
              .map(dateObject => dateObject.Date),
        }));
      }
      
      const generateMondayAttributes = () => {
        //if(wishPeriod === null || wishPeriod === undefined)
        if (calendarstart.value === null || calendarend.value === null)
          return [];

        const mondays = [];
        let current = new Date(calendarstart.value);

        // Find the first Monday of the month
        while (current.getDay() !== 1) {
          current.setDate(current.getDate() + 1);
        }

        // Collect all Mondays in the range
        while (current <= calendarend.value) {
          mondays.push(new Date(current));
          current.setDate(current.getDate() + 7);
        }

        // Assign colors in two-week blocks
        return mondays.map((monday, index) => ({
          dates: monday,
          dot: Math.floor(index / 2) % 2 === 0 ? 'red' : 'blue',
        }));
      };
      
      return [...dynamicAttributesRules,...generateMondayAttributes(), ...baseAttributeContent, dynamicAttributesVacation, ...dynamicAttributesHolidays];
    });

    watch(() => props.employWishData, async (newEmployWishData) => {
      if (!newEmployWishData) return; // Falls `null` oder `undefined`, abbrechen
      // Kalender-Daten zurücksetzen
      fullEmployWishData.value = null
      employVacationData.value = null

      wishPeriod = props.wishPeriod
//      console.log("NEW wishPeriod", wishPeriod, calendar.value)
      calendarstart.value = wishPeriod.startDate.toDate()      
      calendarend.value = wishPeriod.endDate.toDate()
      console.log("Calendar 1",calendarstart.value,calendarend.value)
      // Falls der Calendar-Ref vorhanden ist, ihn "neu laden"
      if (calendar.value) {
        //calendar.value.move(calendarstart.value); // Eine Bewegung erzwingen, um die UI zu aktualisieren
        calendar.selectedDate = calendarstart.value
      }
//      console.log("Wishperiod change", newEmployWishData, wishPeriod, props.wishPeriod)
      //const userData = await GetUserData(newEmployWishData.userId);
      fullEmployWishData.value = await GetWishData(newEmployWishData.wishPeriodId, newEmployWishData.employNr);
      employVacationData.value = await GetEmployVacationData(newEmployWishData.employNr)//(userData.EmployData?.emplno);
//      console.log("Data Read", userData)
    }, { deep: true, immediate: true }) 
/*    
    onMounted(async () => {
      if(employWishData === null || employWishData === undefined)
        return;
      
      const userData = await GetUserData(employWishData.userId);
      
      fullEmployWishData.value = await GetWishData(employWishData.wishPeriodId, employWishData.userId);
      employVacationData.value = await GetEmployVacationData(userData.EmployData?.emplno);
    });
*/    
    return {columns, expanded, wishPeriod, attributes, calendar, calendarstart, calendarend, shiftStrings}
  },
  props: {
    wishPeriod: {
      type: Object,
      default: null,
    },
    employWishData: {
      type: Object,
      default: null,
    },
    ruleBreaks: {
      type: Array,
      default: null,
    }
  },
  emits: ['dayclick'],
  methods: {
    dayClick(date) {
      this.$emit('dayclick', date);
    }
  }
})
</script>